import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'sales-completions-customer-documents',
  storeModule.createStoreModule('sales-completions-customer-documents')
)
